export { cn } from '@employer-on-record/ui';
export { formatIDR, formatIDRShort, formatNumber, parseNumber, initials, formatDateShort, formatDateRange } from '@employer-on-record/shared';

export const TONE_BY_LEAVE_STATUS = {
	pending: 'amber',
	approved: 'green',
	rejected: 'red',
	cancelled: 'gray'
} as const;

export const TONE_BY_REIMBURSEMENT_STATUS = {
	pending: 'amber',
	approved: 'green',
	rejected: 'red',
	sent_to_paid: 'violet',
	reimbursed: 'blue'
} as const;

export const LABEL_BY_REIMBURSEMENT_STATUS = {
	pending: 'Pending',
	approved: 'Approved',
	rejected: 'Rejected',
	sent_to_paid: 'Sent to paid',
	reimbursed: 'Reimbursement paid'
} as const;

export const LABEL_BY_LEAVE_TYPE = {
	annual: 'Annual Leave',
	sick: 'Sick Leave',
	personal: 'Personal',
	maternity: 'Maternity Leave',
	paternity: 'Paternity Leave',
	unpaid: 'Unpaid Leave'
} as const;

export const LABEL_BY_REIMBURSEMENT_CATEGORY = {
	travel: 'Travel',
	meals: 'Meals',
	equipment: 'Equipment',
	software: 'Software',
	training: 'Training',
	other: 'Other'
} as const;

export function avatarPalette(name: string): number {
	if (!name) return 1;
	return ((name.charCodeAt(0) + name.length) % 8) + 1;
}
